<template>
  <jw-cascader v-model="selectVal" @change="changeSelect" :options="options" :placeholder="subcol.placeholder || $t('请选择')" :allow-clear="subcol.allowClear === false ? false : true" :multiple="subcol.multiple === true ? true : false" :max-tag-count="subcol.maxTagCount === undefined ? 1 : subcol.maxTagCount" :check-strictly="subcol.checkStrictly === true ? true : false" :allow-search="allowSearch" :field-names="subcol.dataProps" :path-mode="subcol?.pathMode === undefined ? false : true" :popup-containter="subcol.target || 'body'" :value-key="subcol?.valueKey === undefined ? 'value' : subcol.valueKey" :trigger-props="{ updateAtScroll: true }"> </jw-cascader>
</template>

<script setup>
import { ref, computed, watchEffect, h } from 'vue';
const props = defineProps({
  subcol: {
    type: Object,
    default() {
      return {};
    }
  }
});
const emits = defineEmits(['cb']);
const selectVal = ref(props.subcol.value);
const options = ref(props.subcol.data || []);
const setDisabledOPtion = (options) => {
  options.forEach((option) => {
    let render = null;
    if (!option.isEnabled) {
      //false 禁用
      render = () => {
        return h(
          'span',
          {
            style: {
              color: 'var(--color-text-4)',
              cursor: 'pointer'
            }
          },
          option.label
        );
      };
      option.render = render;
    }
    if (option.children) {
      setDisabledOPtion(option.children);
    }
  });
  return options;
};
options.value = setDisabledOPtion(options.value);
// 是否允许搜索，单选默认不允许，多选默认允许，用户可以自己定义是否允许
const allowSearch = computed(() => {
  let flag = true;
  if (props.subcol.multiple) flag = true;
  else flag = false;
  if (props.subcol.allowSearch === false) flag = false;
  if (props.subcol.allowSearch === true) flag = true;
  return flag;
});

watchEffect(() => {
  options.value = props.subcol.data || [];
  selectVal.value = props.subcol.value;
});
// select 事件
const o = ref({});
const changeSelect = (v) => {
  console.log(33, v);
  o.value = {};
  let pv = v;
  if (props.subcol.multiple) {
    if (pv.length === 0) pv = undefined;
  } else {
    if (pv === '') pv = undefined;
  }

  o.value[props.subcol.name] = pv;
  emits('cb', o.value);
};
</script>
<style scoped lang="less">
@import './xl-cascader.less';
</style>
